<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>افزودن روند</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>از تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.sequence_start_from.val" type="datetime"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.sequence_start_from.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <label>تا تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.sequence_end_at.val" type="datetime"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.sequence_end_at.inv}}</small>
                                </CCol>  
                                <CCol sm="3">
                                    <CInput v-model="form.every_n_minute.val" :description="form.every_n_minute.inv" dir="ltr" label="هر X دقیقه" />
                                </CCol>                             
                            </CRow>
                            <br>
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.every_n_minute_send_count.val" :description="form.every_n_minute_send_count.inv" dir="ltr" label="تعداد ارسال در هر X دقیقه" />
                                </CCol> 
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> افزودن</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                user_id: {val: this.$store.state.user_id, inv: '', v: { req: true, max: 8 }},
                sequence_start_from: {val: '', inv: '', v: { req: true, max: 64 }},
                sequence_end_at: {val: '', inv: '', v: { req: true, max: 64 }},
                every_n_minute: {val: '', inv: '', v: { req: true, max: 256 }},
                every_n_minute_send_count: {val: '', inv: '', v: { req: true, max: 256 }},
			},
            users: [],
            disable: false,
        }
    },
    mounted(){
        this.get_users();
    },
    methods: {
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                data.set('gradual_sms_group_id', this.$route.params.id);
                this.axios.post('out_box_gradual_sms_send_sequences/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'افزودن با موفقیت انجام شد.'
                        });
                        for (const key in this.form){
                            this.form[key].val = '';
                        }
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'خطا! لطفا مجددا تلاش کنید.'
                        });
                    })
            }
        },
        get_users(){
            this.axios.get('users/?type=add_out_box_gradual_sms_send_sequences')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
    },
	beforeCreate(){
        if(this.$store.state.perms.can_add_out_box_gradual_sms_send_sequences == false
            && this.$store.state.can_add_out_box_gradual_sms_send_sequences_for_same_group_users == false
            && this.$store.state.can_add_out_box_gradual_sms_send_sequences_for_all_users == false
            && this.$store.state.verif == false){
			this.$router.push('/403')
		}
	},
}
</script>
